






















import Vue from 'vue';
import { Opportunity, OpportunityMember } from '@/models/opportunities';
import { getGeekDetails } from '@/shared';

export default Vue.extend({
  name: 'OpportunityMembers',
  props: {
    opportunity: Object as () => Opportunity,
  },
  methods: {
    getGeekDetails,
  },
});
